import { render } from "./BatchPassDialog.vue?vue&type=template&id=1b401410"
import script from "./BatchPassDialog.vue?vue&type=script&lang=js"
export * from "./BatchPassDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__